import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import ListCustomersContainer from "../containers/customers/ListCustomersContainer";
import List from "../views/customers/ListCustomers";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const CustomersPage = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Ecat">
      <Box p={2}>
        <Box mb="7%">
          <ListCustomersContainer>
            {({ content, onSwitchAction }) => (
              <List
                items={content ? content : []}
                onSwitchAction={onSwitchAction}
              />
            )}
          </ListCustomersContainer>
        </Box>
      </Box>
    </Page>
  );
};

export default CustomersPage;
